module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/FreeIssue-Amistad.1ec04f18.png";